export enum CardType {
  DC = 'DC',
  CC = 'CC',
  SCC = 'SCC',
  PC = 'PC'
}

export enum CardTypeName {
  DC = '储蓄卡',
  CC = '信用卡',
  SCC = '准贷记卡',
  PC = '预付费卡'
}
